import './SingleValueRenderer.css';
export var chartStateHandler = '_acz2s82-2-0-1';
export var singleValueContainer = '_acz2s80-2-0-1';
export var singleValueInnerContainer = '_acz2s81-2-0-1';
export var sparklineArea = '_acz2s83-2-0-1';
export var trendArea = '_acz2s84-2-0-1';